import moment from 'moment'
import { useSelector } from 'react-redux'

import styles from './EditTextDialog.module.scss'
import { optOutText } from './utils/textContentStrings'

export const TextPreview = ({ children, header }) => {
  return (
    <div>
      {header && <div className={styles.previewHeader}>{header}</div>}
      <div className={styles.previewDialog}>
        <div className={styles.previewInner}>{children}</div>
      </div>
    </div>
  )
}

export const TextPreviewBubble = ({
  prologue = '',
  text,
  defaultData,
  hasOptOutText,
  hasLink,
  customLink
}) => {
  const isDemoMode = useSelector(s => s.login.isDemoMode)

  if (!text) {
    return null
  }

  const url = customLink || 'on.savibook/hsa88'

  function replaceTags(text) {
    const name = defaultData.userName.substring(0, defaultData.userName.indexOf(' '))
    const hotelName = isDemoMode ? 'Directful Demo Hotel' : defaultData.hotelName
    const promoName = defaultData.promotionName
    return text
      .replace(/@\[(\S+)\]\((__)?(\S+)(__)?\)/gm, '$1')
      .replace('guestName', name)
      .replace('hotelName', hotelName)
      .replace('promoName', promoName)
      .replace('inviteLink', '|' + url + '|')
      .replace('checkinDate', moment().add(1, 'day').format('MMM D, YYYY'))
      .replace('checkoutDate', moment().add(3, 'day').format('MMM D, YYYY'))
      .replace(optOutText, '')
      .split(/\||/g)
      .map((part, i) =>
        part.includes('on.savibook') ? (
          <span className={styles.bubbleLink} key={`t-${i}`}>
            {part}
          </span>
        ) : (
          <span key={`t-${i}`}>{part}</span>
        )
      )
  }
  return (
    <div className={styles.textBubble}>
      <span style={{ opacity: 0.4 }}>{replaceTags(prologue)}</span>
      {replaceTags(text)}
      {hasOptOutText && '\n' + optOutText}
      {hasLink && <span className={styles.bubbleLink}>{url}</span>}
      <span className={styles.bubbleTail}></span>
    </div>
  )
}
